module.exports = __webpack_public_path__ + "static/shar-DND3_FnP-b134304aad7273edeea055e1f1c8b026.jpg";